import { all, takeEvery, takeLatest, put, fork, select } from 'redux-saga/effects';
import cartActions, { getDeliveryAddress } from './CartAction';
import { getCartItems, getDeliveryAddreslist, getRelativeList } from './CartServices';
import types from './types';

export const getUser = state => state.auth;

export function* fetchCartItems() {
    const user = yield select(getUser);
    try {
        const response = yield getCartItems(user.uuid);
        yield put({ type: types.GET_CART_ITEMS_SUCCESS, payload: response.data });
    } catch (error) {
        console.log(error)
    }
}


// export function* fetchDeliveryAddress(cartId) {
//     console.log(cartId)
//     try {

//         const response = yield getDeliveryAddreslist(cartId);
//         yield put({ type: types.GET_DELIVERY_ADDRESS_SUCCESS, payload: response.data });
//     } catch (error) {
//         console.log(error)

//     }
// }


export function* fetchRelatives() {

    try {
        const user = yield select(getUser);
        const response = yield getRelativeList(user.uuid);
        yield put({ type: types.GET_RELATIVE_SUCCESS, payload: response.data });
    } catch (error) {
        console.log(error)

    }
}

export function* cartWatcher() {
    yield takeLatest(types.GET_CART_ITEMS, fetchCartItems)
    // yield takeLatest(types.GET_DELIVERY_ADDRESS, fetchDeliveryAddress)
    yield takeLatest(types.GET_RELATIVE, fetchRelatives)
}

export default function* cartSaga() {
    yield all([cartWatcher()]);
}
